export default async (value, bookingEngine) => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const result = await bookingEngine.validatePostalCode({ postalCode: value });
  return result.items.some(
    item => 'postal_code' in item && item.postal_code === value.replace(/ /g, '').toLowerCase(),
  );
};
